import { appConfig } from '@common/config';
import { SearchForm } from '@components/SearchForm';
import { Index as DetailIndex } from '@components/detail/Index';
import { type IPriceParams } from '@interface/IItemPrice';
import { store, useAppDispatch } from '@store/index';
import { setIsFilterOpen } from '@store/priceSlice';
import { type ComponentType } from 'react';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router';
import { FilterWrapL2m } from './FilterWrapL2m';
import { FilterWrapLm } from './FilterWrapLm';
import { ResultWrap } from './ResultWrap';

const componentMap: Record<string, ComponentType<any>> = {
    l2m: FilterWrapL2m,
    lms: FilterWrapLm,
};

export async function loader({ request }: Record<string, any>): Promise<IPriceParams> {
    const url = new URL(request.url as string);
    return {
        paramServerid: url.searchParams.get('serverid'),
        paramQuery: url.searchParams.get('query')?.replace(/%20/g, ' ') || null,
        // paramQuery: url.searchParams.get('query'),
        paramGrade: url.searchParams.get('grade'),
        paramClass: url.searchParams.get('class'),
        paramPage: url.searchParams.get('page'),
        paramSale: url.searchParams.get('sale'),
        paramEnchantfrom: url.searchParams.get('enchantfrom'),
        paramEnchantto: url.searchParams.get('enchantto'),
        paramCategory1: url.searchParams.get('category1'),
        paramCategory2: url.searchParams.get('category2'),
        paramBless: url.searchParams.get('bless'),
        paramFavorite: url.searchParams.get('favorite'),
        paramExactsearch: url.searchParams.get('exactsearch'),
        paramDetail: url.searchParams.get('detail'),
    };
}

const Main = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const params = useLoaderData() as IPriceParams;
    const CurrentFilter = componentMap[appConfig.service];

    return (
        <>
            <SearchForm
                props={{
                    placeholderStr: t('common.placeholder'),
                    watch: 'query',
                    value: params.paramQuery,
                    resetObj: { page: '1' },
                    apiPath: '/v2.0/price/search/item/suggest',
                    submitCallback: (_q: string) => console.log('q', _q),
                }}
            >
                <button className="btn-filter" onClick={() => dispatch(setIsFilterOpen(!store.getState().price.isFilterOpen))}>
                    {t('price.searchconditionsbtn')}
                </button>
            </SearchForm>

            <div className="gameinfo-item-wrapper">
                <CurrentFilter props={params} />
                <ResultWrap params={params} />
                <div style={{ position: 'fixed', zIndex: 9999999, inset: 0, pointerEvents: 'none' }}>
                    <Toaster />
                </div>
            </div>

            <DetailIndex paramDetail={params.paramDetail} />
        </>
    );
};

export default Main;
